import React, { isValidElement, useContext, useEffect } from 'react';
import moment from 'moment';
import { isDefined, resolveColor } from '@philips-internal/oswald-ui-utils';
import { InlineImage } from '../../inline-image/inline-image.js';
import { LegendsContext } from '../../legends/legends-context.js';
import { RELATIVE_TICK_POSITION, TimelineInterval } from '../timeline-constants.js';
import { getAbsolutePosition, getFitAbsolutePosition } from '../timeline-position-utils.js';
import { getSchedulerWidth, getSuperscription } from '../timeline-utils.js';
import './timeline-scheduler-event.css';
const DEFAULT_IMAGE = '/static/assets/components/timeline/DLS_AnnotationCircle.svg';
function TimelineSchedulerEvent(props) {
    const { data, interval, intervals, superscription, superscriptionEntry } = props;
    const context = useContext(LegendsContext);
    useEffect(() => {
        if (!context || !superscription.length) {
            return;
        }
        const eventSuperscription = getSuperscription(data[superscriptionEntry], superscription);
        if (!eventSuperscription) {
            return;
        }
        context.addItem(eventSuperscription);
        return () => {
            context.removeItem(eventSuperscription.value);
        };
    }, [superscription, superscriptionEntry, context?.addItem, context?.removeItem]);
    const hasIntervals = intervals.length;
    if (!hasIntervals) {
        return null;
    }
    const position = (date) => {
        const dt = moment(date);
        if (interval === TimelineInterval.FIT) {
            return getFitAbsolutePosition(dt, intervals);
        }
        return getAbsolutePosition(dt, interval, intervals) + RELATIVE_TICK_POSITION;
    };
    const getLongDurantionPosition = (start, end) => {
        const startPosition = position(start);
        const endPosition = position(end);
        return endPosition - startPosition;
    };
    const getIcon = () => {
        const eventSuperscription = getSuperscription(data[superscriptionEntry], superscription);
        if (isDefined(eventSuperscription) && isValidElement(eventSuperscription.icon)) {
            return eventSuperscription.icon;
        }
        return (React.createElement(InlineImage, { className: "c-timeline-scheduler-event__svg", src: eventSuperscription?.icon || DEFAULT_IMAGE }));
    };
    const getItemIcon = () => {
        if (data.end && data.start) {
            const width = getLongDurantionPosition(data.start, data.end);
            return (React.createElement("div", { className: "c-timeline__long-duration", style: { maxWidth: `${width}rem`, minWidth: `${width || 6}rem` } },
                React.createElement("span", { className: "c-timeline__long-duration__text" }, data.longDurationDescription)));
        }
        const eventSuperscription = getSuperscription(data[superscriptionEntry], superscription);
        return (React.createElement("div", { className: "c-timeline-scheduler-event__icon", style: resolveColor(eventSuperscription?.color ?? 'signal-gray-40') }, getIcon()));
    };
    return (React.createElement("div", { className: "c-timeline-scheduler-event", style: { minWidth: `${getSchedulerWidth(intervals.length)}rem` } }, data.start ? (React.createElement("div", { className: "c-timeline-scheduler-event__item", style: { left: `${position(data.start)}rem` } }, getItemIcon())) : null));
}
export { TimelineSchedulerEvent, };
//# sourceMappingURL=timeline-scheduler-event.js.map